import { redirect, type RouteObject } from "react-router";

import { ErroApi } from "../api/cliente";
import { verSessao } from "../api/prisma";
import { comEsperaDoServidor, useEsperandoServidor } from "../api/subida";
import { AnalisePagina, CardPrivado, CardPublico } from "../paginas/CardPagina";
import { PaginaErro } from "../paginas/Erro";
import { Layout } from "./Layout";

async function exigirSessao() {
  try {
    // Na primeira carga do `just dev` o servidor pode ainda estar subindo.
    await comEsperaDoServidor(verSessao);
  } catch (erro) {
    // O roteador trata a resposta de `redirect` lançada pelo loader.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    if (erro instanceof ErroApi && erro.status === 401) throw redirect("/entrar");
    throw erro;
  }
  return null;
}

/** O que aparece enquanto a primeira carga espera; só fala do servidor se ele demorar. */
function Iniciando() {
  const esperando = useEsperandoServidor();
  return esperando ? <p role="status">Iniciando o servidor…</p> : null;
}

/** Rotas na mesa com inspetor (trilho, centro e inspetor). */
const AMPLA = { largura: "ampla" };

/**
 * Rotas do app (contracts/http-api.md). O card fica no pacote principal: é a página que mais
 * chega por link compartilhado, e precisa abrir depressa no celular de referência (SC-008).
 * O resto carrega sob demanda.
 */
export const rotas = [
  {
    Component: Layout,
    ErrorBoundary: PaginaErro,
    children: [
      {
        index: true,
        handle: AMPLA,
        loader: exigirSessao,
        HydrateFallback: Iniciando,
        lazy: () => import("../paginas/Inicio").then((m) => ({ Component: m.Inicio })),
      },
      {
        path: "entrar",
        lazy: () => import("../paginas/Entrar").then((m) => ({ Component: m.Entrar })),
      },
      { path: "c/:token", Component: CardPrivado, handle: AMPLA },
      { path: "card/:id", Component: CardPublico, handle: AMPLA },
      { path: "analise/:id", Component: AnalisePagina, handle: AMPLA },
      {
        path: "card/:id/recibo",
        lazy: () => import("../paginas/Recibo").then((m) => ({ Component: m.Recibo })),
      },
      {
        path: "metodo",
        lazy: () => import("../paginas/Metodo").then((m) => ({ Component: m.Metodo })),
      },
      {
        path: "selecao",
        lazy: () => import("../paginas/Selecao").then((m) => ({ Component: m.Selecao })),
      },
      { path: "*", Component: () => <PaginaErro naoEncontrada /> },
    ],
  },
] satisfies RouteObject[];
